<template>
  <vue-select
    style="width: 100%"
    :value="value"
    @search="getOptions"
    id="jurusan"
    :options="items"
    label="name"
    class="select-x"
    placeholder="Pilih Jurusan SMA"
    @input="changed"
  ></vue-select>
</template>

<script>
import { HTTPAUTH } from "../lib/httplib";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    VueSelect,
  },
  name: "MajorSelector",
  data() {
    return {
      items: [],
    };
  },
  props: ["value"],
  created() {
    this.init("");
  },
  methods: {
    init(q) {
      HTTPAUTH.get(`/api/v1/major?q=${q}`).then((res) => {
        this.items = res.data.data;
      });
    },
    getOptions(search, loading) {
      loading(true);
      this.init(search);
      loading(false);
    },
    changed(evt) {
      this.$emit("input", evt);
    },
  },
};
</script>

<style scoped>
</style>
